// React & Vendor Libs
const { useState, useCallback } = wp.element;
import Styled from "styled-components";

// Libs
import i18n from '@app/i18n';
import { apiUrl, restNonce } from '@app/settings';

// NekoUI
import { NekoTypo, NekoIcon, NekoModal, NekoInput, NekoSelect, NekoOption } from '@neko-ui';
import { postFetch } from '@neko-ui';

const targets = [
	{ label: i18n.SAME_PAGE, value: '_self' },
	{ label: i18n.NEW_PAGE, value: '_blank' }
];

const GroupContainer = Styled.div`
	align-items: center;
	display: flex;
	margin-bottom: 10px;

	p {
		margin: 0 !important;
		width: 20%;
	}

	> div {
		flex-grow: 1;
	}
`;

const EditLinkField = ( props ) => {

	const [ busyAction, setBusyAction ] = useState(false);
	const busy = busyAction;

	const { postId } = props;
	const [ url, setUrl ] = useState( props.url );
	const [ target, setTarget ] = useState( props.target ? props.target : '_self' );
	const [ rel, setRel ] = useState( props.rel );
	const [ aria, setAria ] = useState( props.aria );
	const [ openModal, setOpenModal ] = useState( false );

	const updateOption = async (postId, url, target, rel, aria) => {
		setBusyAction( true );
		let result = true;
		try {
			const res = await postFetch( `${apiUrl}/update_meta`, { json: {
				post_id: postId,
				_gallery_link_url: url,
				_gallery_link_target: target,
				_gallery_link_rel: rel,
				_gallery_link_aria: aria,
			}, nonce: restNonce } );
			if ( !res.success ) {
				result = false;
				alert(res.message);
			}
		} catch ( err ) {
			result = false;
			alert( err.message );
		} finally {
			if ( result ) onCloseModal();
			setBusyAction( false );
		}
	};

	const onCloseModal = () => setOpenModal( false )

	const onOkClick = useCallback(() => {
		updateOption( postId, url, target, rel, aria );
	}, [postId, url, target, rel, aria, updateOption, onCloseModal]);

  const onKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      onOkClick();
    }
  }, [onOkClick]);

	return (
		<>
			<span onClick={() => setOpenModal( true )} style={{ cursor: 'pointer' }}>
				<NekoIcon icon="link" disabled={!url} />
			</span>
			<NekoModal
				isOpen={openModal}
				onRequestClose={onCloseModal}
				title="Edit the custom link"
				content={
					<div>
						<GroupContainer>
							<NekoTypo p>{i18n.LINK_URL}</NekoTypo>
							<NekoInput name='mgcl-link-url' disabled={busy} onInput={(e) => setUrl(e.target.value)} onKeyDown={onKeyDown} value={url} autoFocus />
						</GroupContainer>
						<GroupContainer>
							<NekoTypo p>{i18n.LINK_TARGET}</NekoTypo>
							<NekoSelect name='mgcl-link-target' scrolldown={true} value={target} onChange={(v) => setTarget(v)} disabled={busy}>
								{targets.map(target => <NekoOption value={target.value} label={target.label} />)}
							</NekoSelect>
						</GroupContainer>
						<GroupContainer>
							<NekoTypo p>{i18n.LINK_REL}</NekoTypo>
							<NekoInput name='mgcl-link-rel' disabled={busy} onInput={(e) => setRel(e.target.value)} value={rel} />
						</GroupContainer>
						<GroupContainer>
							<NekoTypo p>{i18n.ARIAL_LABEL}</NekoTypo>
							<NekoInput name='mgcl-arial-label' disabled={busy} onInput={(e) => setAria(e.target.value)} value={aria} />
						</GroupContainer>
					</div>
				}
				onOkClick={onOkClick}
				onCancelClick={onCloseModal}
			/>
		</>
	);
};

export default EditLinkField;